import UserService from '../services/user.service.js';

const initialState = {};

export const user = {
  namespaced: true,
  state: initialState,
  getters: {
    client: (_state, _getters, rootState) => {
      return new UserService(rootState.auth.user.token);
    },
  },
  actions: {
    register({ getters, dispatch }, user) {
      const client = getters.client;
      return client
        .registerUser(user)
        .then(() => {})
        .catch((error) => {
          console.log(error);
          if (error.isError && error.status == 401) {
            dispatch('auth/logout', {}, { root: true });
          }
          throw error;
        });
    },
    updateRegistration({ getters, dispatch }, user) {
      const client = getters.client;
      return client
        .updateRegistration(user)
        .then(() => {})
        .catch((error) => {
          console.log(error);
          if (error.isError && error.status == 401) {
            dispatch('auth/logout', {}, { root: true });
          }
          throw error;
        });
    },

    addRole({ getters, dispatch }, role) {
      const client = getters.client;
      return client
        .addRole(role)
        .then(() => {})
        .catch((error) => {
          console.log(error);
          if (error.isError && error.status == 401) {
            dispatch('auth/logout', {}, { root: true });
          }
          throw error;
        });
    },

    // A user holds exactly one role, so the admin screen sets it rather than adding and removing.
    // setRole grants before it revokes, so the account is never momentarily roleless -- which
    // would fail the API's baseline access check.
    setRole({ getters, dispatch }, role) {
      const client = getters.client;
      return client
        .setRole(role)
        .then(() => {})
        .catch((error) => {
          console.log(error);
          if (error.isError && error.status == 401) {
            dispatch('auth/logout', {}, { root: true });
          }
          throw error;
        });
    },

    updatePassword({ getters, dispatch }, password) {
      const client = getters.client;
      return client
        .updatePassword(password)
        .catch((error) => {
          console.log(error);
          if (error.isError && error.status == 401) {
            dispatch('auth/logout', {}, { root: true });
          }
          // Rethrow: swallowing here resolved the promise even on failure, so the
          // caller's .catch() never ran -- the password dialog reported nothing
          // whether the save worked or not.
          throw error;
        });
    },
  },
  mutations: {},
};
